/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Step_ConfirmInputs */



/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {New_Project_Step_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_step_confirm = /** @type {((inputs?: New_Project_Step_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Step_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestätigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Confermare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтверждать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Confirmar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确认")
	if (locale === "ja") return /** @type {LocalizedString} */ ("確認する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुष्टि करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Confirmar")
	return /** @type {LocalizedString} */ ("Confirm")
});